import React from "react";
import {
  PopHeader,
  InfoWrapperDiv,
  QuestionWrap,
  AnswerWrap,
  QASection,
  DisplayFlexOkay,
  QASectionWrapper,
  ElectronicMailerInfoContentWrapper,
  ElectronicDeliveryIconWrap
} from "../styles";
import Close from '../../../../../assets/icons/close-small.svg';
import { ContentMessage, Types } from '../../../../../CommonComponents/ContentMessages';
import { GeneralButton } from "../../../../../CommonComponents/Commons/commonComponents";

class ViewAdditionalInfo extends React.Component {  
  componentDidMount() {
    document.body.style.overflow = "hidden";
  }
  componentWillUnmount() {
    document.body.style.overflow = "auto";
  }
  render() {
    return (
      <InfoWrapperDiv>
        <ElectronicMailerInfoContentWrapper>
          <ElectronicDeliveryIconWrap>
            <img src={Close} alt="Cross" onClick={this.props.handleOkay} className='deliveryPopupClose' id="deliveryPopupCloseIcon"/>
          </ElectronicDeliveryIconWrap>
          <PopHeader className='electronicPopupHeader'>
            <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_title" defaultMessage="Important information regarding electronic delivery" />
          </PopHeader>

          <QASection scrollView>
            <QASectionWrapper className="electronicDeliveryContentWrapper">
              <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_1_title" defaultMessage="How is the electronic delivery option applied and how long does it last?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_1_descriptn" defaultMessage="<p>Your indicated preference applies to all documents that can be delivered electronically for all accounts where you are authorized to access accountinformation. It will be effective until you or Vanguard Charitable revoke it.</p>" />
              </AnswerWrap>
              <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_2_title" defaultMessage="How will I know when documents are available online?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_2_descriptn" defaultMessage="<p>You may receive an email when a new document is made available online.</p>" />
              </AnswerWrap>
              <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_3_title" defaultMessage="When and how will I see documents online?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_3_descriptn" defaultMessage="<p>Transaction confirmations are generally available online two to three business days after the activity is complete. Account statements are available online approximately five days after the end of each period. To view a document online, click My account at vanguardcharitable.org. Enter your user ID and password, click Log in, and you will be directed to the Account summary page. Click the Reports tab and you will be brought to the Statements and confirmations page.</p>" />
              </AnswerWrap>
              <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_4_title" defaultMessage="How are documents retained?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_4_descriptn" defaultMessage="<p>Download or print account documents under Reports in your online account or contact us to request copies.</p>" />
              </AnswerWrap>
              <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_5_title" defaultMessage="Do I need special software for electronic delivery?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_5_descriptn" defaultMessage="<p>You must have Adobe Acrobat Reader to view account reports online. You can download this software free from Adobe's website at www.adobe.com.</p>" />
              </AnswerWrap>
              <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_6_title" defaultMessage="How do I change my contact information or my delivery preferences?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_6_descriptn" defaultMessage="<p>Log in to your philanthropic account.Navigate to Profile under Account in the top gray bar. Click Edit by the respective subject to change contact information or delivery preferences.</p>" />
              </AnswerWrap>
            </QASectionWrapper>
            <QASectionWrapper  className="electronicDeliveryContentWrapper">
            <QuestionWrap>
                 <ContentMessage type={[Types.GET_MODAL_CONTENT]} page="Delivery Method" property="field_modal_content_7_title" defaultMessage="What other e-delivery issues should I consider?" />
              </QuestionWrap>
              <AnswerWrap>
                <ContentMessage type={[Types.GET_MODAL_CONTENT]} html={true} page="Delivery Method" property="field_modal_content_7_descriptn" defaultMessage="<p>Sometimes errors occur in email transmission. If you do not receive an expected email notification, log in to your account to view the information or contact us.</p>" />
              </AnswerWrap>
            </QASectionWrapper>
          </QASection>
          <DisplayFlexOkay border={true}>
            <GeneralButton onClick={this.props.handleOkay}
             id="btnDeliveryPopupOk"
             text="OKAY"
             type="functional"
             width="150px"
             styling='okayButtonAlignment'
            >
            </GeneralButton>
          </DisplayFlexOkay>
        </ElectronicMailerInfoContentWrapper>
      </InfoWrapperDiv>
    );
  }
}

export default ViewAdditionalInfo;
